class ParrentModel<ValueType> {
  value: ValueType;

  constructor(value: ValueType) {
    this.value = value;
  }
}

export { ParrentModel };
